<div *ngFor="let roteiro of dashboardResult; let i = index">
  <div class="row container bg-white" style="border:1px solid #C0C1C3"  *ngIf="filtroVisitaAtivoIDs.includes(roteiro.IdRoteiroSituacao)">
    <div class="col-5 abrir-roteiro" style="border-right: 1px solid #C0C1C3;" >      
      <div class="d-flex w-100">
        <app-info-roteiro-visita class="w-75" [roteiro]="roteiro"   data-bs-toggle="modal" data-bs-target="#modalPrincipal" (click)="abrirRoteiro(roteiro)" ></app-info-roteiro-visita>
        <app-info-roteiro-visita class="w-25"[roteiro]="roteiro" [somenteTemperatura]="true" ></app-info-roteiro-visita>
      </div>
      <app-info-entregas-visita [roteiro]="roteiro" data-bs-toggle="modal" data-bs-target="#modalPrincipal" (click)="abrirRoteiro(roteiro)" ></app-info-entregas-visita>      
    </div>

    <div class="col-7">      
      <app-status-cliente-visita class="d-flex flex-wrap" 
          [roteiro]="roteiro"  
          [index]="i" 
          [ultimoRoteiro]="i + 1 == dashboardResult.length"
          [dadosVisitas]="dadosVisitas"
          ></app-status-cliente-visita>
    </div>
  </div>
</div>


<app-popup-msg-oc 
  *ngIf="boxInfoAlertService.abrirModalMensagemOc" 
  [mensagem]="boxInfoAlertService.mensagemModal" 
  [data]="boxInfoAlertService.dataModal">
</app-popup-msg-oc>